/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentSharedPaymentTypes200,
  GetApiV1IndividualpaymentSharedPaymentTypes401,
  GetApiV1IndividualpaymentSharedPaymentTypes500,
  GetApiV1IndividualpaymentSharedPaymentTypesQueryParams,
  GetApiV1IndividualpaymentSharedPaymentTypesQueryResponse,
} from "../../types/individualPaymentSharedController/GetApiV1IndividualpaymentSharedPaymentTypes.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1IndividualpaymentSharedPaymentTypesQueryParamsSchema =
  z.object({
    culture: z.string().default("pt-BR"),
  }) as unknown as ToZod<GetApiV1IndividualpaymentSharedPaymentTypesQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentSharedPaymentTypes200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1IndividualpaymentSharedPaymentTypes200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentSharedPaymentTypes401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentSharedPaymentTypes401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentSharedPaymentTypes500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentSharedPaymentTypes500>;

export const getApiV1IndividualpaymentSharedPaymentTypesQueryResponseSchema =
  z.lazy(
    () => getApiV1IndividualpaymentSharedPaymentTypes200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentSharedPaymentTypesQueryResponse>;
